import React from "react";
import { cn } from "@/lib/utils";

/**
 * Rubber-stamp badge from the home mockup (system-side-by-side.html .stamp):
 * Georgia serif, rotated -2.5°, 2px border in the "stamp" accent (--accent-green
 * — mint in dark, emerald in light).
 *
 *  - outlined (default) = a pending action, e.g. APPROVE. Pass `onClick` to make
 *    it a real quick-action button (fills on hover to signal it's clickable).
 *  - `done` = filled solid, e.g. DONE (a completed item).
 */
export function Stamp({ label, done = false, onClick, className, title }) {
  const base =
    "inline-flex shrink-0 items-center rounded border-2 border-[color:var(--accent-green)] px-2 py-px text-[9.5px] font-bold uppercase leading-tight tracking-[0.06em] [font-family:Georgia,'Times_New_Roman',serif] [transform:rotate(-2.5deg)]";

  if (done) {
    return (
      <span className={cn(base, "bg-[color:var(--accent-green)] text-white", className)} title={title}>
        {label}
      </span>
    );
  }

  if (onClick) {
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); }
        }}
        title={title}
        aria-label={title || label}
        className={cn(base, "cursor-pointer text-[color:var(--accent-green)] transition-colors hover:bg-[color:var(--accent-green)] hover:text-white", className)}
      >
        {label}
      </span>
    );
  }

  return (
    <span className={cn(base, "text-[color:var(--accent-green)]", className)} title={title}>
      {label}
    </span>
  );
}
